<template>
    <div
        v-if="favoritesType"
        class="o-protectors"
    >
        <m-tabs
            :items="favoritesTypes"
            @input="favoritesType = $event.value"
            :selected="favoritesType"
        />
        <o-list
            v-if="favoritesType === 'protectors'"
            vuex-action-fetch="fetchProtectors"
            vuex-action-fetch-next-page="fetchProtectorsNextPage"
            vuex-getter-model="protectors"
            vuex-getter-status="protectorsStatus"
            router-single-name="protector"
        >
            <template slot="list" slot-scope="props">
                <div class="m-list__itemPhoto">
                    <a-image
                        v-if="props.list.item.photos && props.list.item.photos.length > 0 && !!props.list.item.photos.find(item => item.is_main === true)"
                        :src="props.list.item.photos.find(item => item.is_main === true).full_uri"
                        :alt="props.list.item.name"
                    />
                    <figure
                        v-else
                        class="a-image"
                    ></figure>
                </div>
                <p
                    class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize"
                    :style="authIsAdvisor && props.list.item.position_group ? { color: props.list.item.position_group.hex } : false"
                >
                    {{ props.list.item.name }}
                </p>
                <div class="m-list__itemIcons">
                    <a-icon
                        v-if="props.list.item.youtube_link"
                        class="m-list__icon"
                        icon="Video"
                    />
                    <a-icon
                        class="m-list__icon"
                        :icon="props.list.item.notes && props.list.item.notes.length > 0 ? 'Note' : 'NoteLight'"
                    />
                    <a-icon
                        class="m-list__icon"
                        :icon="props.list.item.is_favorite ? 'Favorite' : 'FavoriteLight'"
                    />
                </div>
            </template>
        </o-list>
        <o-list
            v-else-if="favoritesType === 'agrii-protectors'"
            vuex-action-fetch="fetchAgriiProtectors"
            vuex-action-fetch-next-page="fetchAgriiProtectorsNextPage"
            vuex-getter-model="agriiProtectors"
            vuex-getter-status="agriiProtectorsStatus"
            router-single-name="agrii-protector"
        >
            <template slot="list" slot-scope="props">
                <div class="m-list__itemPhoto">
                    <a-image
                        v-if="props.list.item.photos && props.list.item.photos.length > 0 && !!props.list.item.photos.find(item => item.is_main === true)"
                        :src="props.list.item.photos.find(item => item.is_main === true).full_uri"
                        :alt="props.list.item.name"
                    />
                    <figure
                        v-else
                        class="a-image"
                    ></figure>
                </div>
                <p
                    class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize"
                    :style="authIsAdvisor && props.list.item.position_group ? { color: props.list.item.position_group.hex } : false"
                >
                    {{ props.list.item.name }}
                </p>
                <div class="m-list__itemIcons">
                    <a-icon
                        v-if="props.list.item.youtube_link"
                        class="m-list__icon"
                        icon="Video"
                    />
                    <a-icon
                        class="m-list__icon"
                        :icon="props.list.item.notes && props.list.item.notes.length > 0 ? 'Note' : 'NoteLight'"
                    />
                    <a-icon
                        class="m-list__icon"
                        :icon="props.list.item.is_favorite ? 'Favorite' : 'FavoriteLight'"
                    />
                </div>
            </template>
        </o-list>
        <a-spinner v-else />
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Ulubione'
    },
    data() {
        return {
            favoritesTypes: [
                {
                    value: 'protectors',
                    label: 'Pestycydy i niepestycydy'
                }, {
                    value: 'agrii-protectors',
                    label: 'Produkty Agrii'
                }
            ],
            favoritesType: ''
        }
    },
    watch: {
        favoritesType() {
            this.fetch()
        }
    },
    computed: {
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        }
    },
    methods: {
        fetch() {
            this.setQuery(this.favoritesType).then(() => {
                if(this.favoritesType === 'protectors') {
                    this.$store.dispatch('fetchProtectors')
                } else if(this.favoritesType === 'agrii-protectors') {
                    this.$store.dispatch('fetchAgriiProtectors')
                }
            })
        },
        setQuery() {
            return new Promise((resolve, reject) => {
                if(this.favoritesType === 'agrii-protectors') {
                    this.$store.dispatch('resetAgriiProtectorsQuery').then(() => {
                        this.$store.dispatch('setAgriiProtectorsSearchQuery', {
                            name: 'favorite',
                            value: 1
                        }).then(() => {
                            resolve()
                        })
                    })
                } else {
                    this.$store.dispatch('resetProtectorsQuery').then(() => {
                        this.$store.dispatch('setProtectorsSearchQuery', {
                            name: 'favorite',
                            value: 1
                        }).then(() => {
                            resolve()
                        })
                    })
                }
            })
        }
    },
    created() {
        this.setQuery(this.favoritesType).then(() => {
            this.favoritesType = 'protectors'
        })
    }
}
</script>
